import * as Config from '../../../../config';
import React from 'react';
import PropTypes from 'prop-types';

import GridFull from './GridFull';
import Card from '../../common/Card';
import CardLoading from '../../common/CardLoading';
import Spinner from '../../common/Spinner';

import useCharts from '../../../../hooks/useCharts';
import useNCCharts from '../../nav-control/hooks/useNCCharts';

function GridCharts(props) {
  const { id, pathApi, width, rowCount, perPage, showLoading, customReduceFormat } = props;
  const perPageCal = perPage ?? Math.floor(width / Config.CARD_WIDTH) * rowCount;
  const [dataHook] = useCharts(id, pathApi, perPageCal, 'CHART', customReduceFormat);

  useNCCharts(id, (dataHook && dataHook.items) ? dataHook.items : null);

  return (dataHook && dataHook.itemsFull && dataHook.itemsFull.length > 0)
    ? <GridFull
        {...props}
        gutter={{ top: 4, left: 4, width: 8 }}
        dataHook={dataHook}
        element={ <Card /> }
        loadingElement={ <CardLoading /> }
      />
    : (showLoading ? <Spinner /> : null)
}

GridCharts.propTypes = {
  id: PropTypes.string.isRequired,
  width: PropTypes.any,
  height: PropTypes.number.isRequired,
  title: PropTypes.string,
  pathApi: PropTypes.string.isRequired,
  hasFilters: PropTypes.bool,
  filtersStyle: PropTypes.object,
  forceHeight: PropTypes.number,
  rowCount: PropTypes.number,
  rowHeight: PropTypes.number,
  columnCount: PropTypes.number,
  hasPagination: PropTypes.bool,
  perPage: PropTypes.number,
  allTo: PropTypes.any,
  style: PropTypes.object
}

export default GridCharts;
